import React from 'react'

class DisabledCookies extends React.Component {
  render = () => (
    <div className="c-message c-message--warning">
      <p>
        You have cookies/web storage disabled. In order for this site to
        function properly, cookies are required.
      </p>
    </div>
  )
}

export default DisabledCookies
